const SLICE_LENGTH: Record<
  'character' | 'guild' | 'community' | 'team',
  number
> = {
  character: 5, // /character/:region/:realm/:character
  guild: 5, // /guild/:region/:realm/:guild
  community: 3, // /community/:community
  team: 7, // /<guild|community>/:region/:realm/:guild/teams/:team
}

const useBasePath = (scope: keyof typeof SLICE_LENGTH) => {
  const pathSegments = window.location.pathname.split('/')

  return pathSegments.length >= SLICE_LENGTH[scope]
    ? pathSegments.slice(0, SLICE_LENGTH[scope]).join('/')
    : undefined
}

export default useBasePath
